import { render, staticRenderFns } from "./StockTransform.vue?vue&type=template&id=5021aa2a&scoped=true"
import script from "./StockTransform.vue?vue&type=script&lang=js"
export * from "./StockTransform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021aa2a",
  null
  
)

export default component.exports